import * as React from 'react';

import { DialogTrigger } from '@radix-ui/react-dialog';
import { FormattedMessage, useIntl } from 'react-intl';

import { statisticsMessages } from 'src/features/statistics/utils';
import { downloadReceipt, generateCanvas } from 'src/features/statistics/utils/digitalReceipt';
import { Button } from 'src/registry/ui/Button';
import { generalMessages } from 'src/utils/messages';

import { ViewDigitalReceiptModal } from './ViewDigitalReceiptModal';

type PaymentDetailsButtonsProps = {
    paymentDate: string;
    digitalReceiptDetails?: string;
};

const PaymentDetailsButtons = ({ paymentDate, digitalReceiptDetails }: PaymentDetailsButtonsProps) => {
    const { formatMessage } = useIntl();

    const [isLoadedFont, setIsLoadedFont] = React.useState(false);

    React.useEffect(() => {
        const ibmPlexMono = new FontFace(
            'IBM Plex Mono',
            'url(https://fonts.gstatic.com/s/ibmplexmono/v19/-F63fjptAgt5VM-kVkqdyU8n1isq131nj-otFQ.woff2)',
        );
        void ibmPlexMono.load().then(() => {
            document.fonts.add(ibmPlexMono);
            setIsLoadedFont(true);
        });
    }, []);

    const receiptTextLines = digitalReceiptDetails?.trimEnd().split('\n');
    const fileName = `${formatMessage(generalMessages.smartPark)} ${formatMessage(statisticsMessages.digitalReceipt)} - ${paymentDate}`;

    const handleDownload = () => {
        const canvas = generateCanvas(receiptTextLines, isLoadedFont);
        downloadReceipt(canvas, fileName);
    };
    return (
        <div className="xs:grid-cols-2 grid gap-2">
            <ViewDigitalReceiptModal downloadReceipt={handleDownload} digitalReceiptDetails={digitalReceiptDetails}>
                <DialogTrigger asChild>
                    <Button variant="outline" className="flex-1" disabled={!digitalReceiptDetails}>
                        <FormattedMessage {...statisticsMessages.viewReceipt} />
                    </Button>
                </DialogTrigger>
            </ViewDigitalReceiptModal>
            <Button variant="outline" className="flex-1" onClick={handleDownload} disabled={!digitalReceiptDetails}>
                <FormattedMessage {...statisticsMessages.downloadReceipt} />
            </Button>
        </div>
    );
};

export default PaymentDetailsButtons;
